module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section02_01_beach-photo-fed6460842f62e9013bf4653b0d54c5a.jpg";